import { call, put, takeLatest } from 'redux-saga/effects';

import { DocumentService, ResponseScan } from '../../../entities/Document';
// import { mockImage } from 'modules/shared/FlightDetails/components/ScanerModal/exp';
import { getScanError, getScanRequest, getScanSuccess } from './actions';
import { GET_SCAN_PHOTO_REQUEST } from './constants';

function* getScan(action: ReturnType<typeof getScanRequest>) {
  try {
    const response: ResponseScan = yield call(DocumentService.getDocumentScan, action.payload);
    // const response: ResponseScan = yield call(mockImage);

    // @ts-ignore
    // eslint-disable-next-line
    if (!!response.message) {
      // @ts-ignore
      yield put(getScanError(response));
    } else {
      yield put(getScanSuccess(response));
    }
  } catch (error: any) {
    yield put(getScanError(error));
  }
}

export function* scanerSagaWatcher() {
  yield takeLatest(GET_SCAN_PHOTO_REQUEST, getScan);
}
